import React from 'react'

const EmptyLoader = () => {
  return <></>
}

export default EmptyLoader
